import { runnerAabbFromCenter, runnerAabbIntersects } from './runnerCollision';
import { computeRunnerPlayerHitbox } from './runnerPlayerHitbox';
import type { RunnerHitbox, RunnerLevel, RunnerObstacle, RunnerPlayer, RunnerSpark, RunnerBoosterPickup } from './runnerTypes';

function hitboxToAabb(hitbox: RunnerHitbox) {
  return runnerAabbFromCenter(
    hitbox.centerS,
    hitbox.centerLane,
    hitbox.widthS,
    hitbox.heightLane,
  );
}

export function detectRunnerObstacleCollisions(
  level: RunnerLevel,
  player: RunnerPlayer,
): RunnerObstacle[] {
  const playerBox = hitboxToAabb(computeRunnerPlayerHitbox(level, player));
  const colliding: RunnerObstacle[] = [];
  for (const obstacle of level.obstacles) {
    if (
      obstacle.consumed ||
      obstacle.touched ||
      obstacle.collides === false ||
      (obstacle.opacity ?? 1) <= 0
    ) {
      continue;
    }
    if (runnerAabbIntersects(playerBox, hitboxToAabb(obstacle.hitbox))) {
      colliding.push(obstacle);
    }
  }
  return colliding;
}

export function detectRunnerSparkCollisions(
  level: RunnerLevel,
  player: RunnerPlayer,
): RunnerSpark[] {
  const playerBox = hitboxToAabb(computeRunnerPlayerHitbox(level, player));
  const colliding: RunnerSpark[] = [];
  for (const spark of level.sparks) {
    if (spark.consumed) {
      continue;
    }
    if (runnerAabbIntersects(playerBox, hitboxToAabb(spark.hitbox))) {
      colliding.push(spark);
    }
  }
  return colliding;
}

export function detectRunnerBoosterCollisions(
  level: RunnerLevel,
  player: RunnerPlayer,
): RunnerBoosterPickup[] {
  const playerBox = hitboxToAabb(computeRunnerPlayerHitbox(level, player));
  const colliding: RunnerBoosterPickup[] = [];
  for (const booster of level.boosters) {
    if (booster.consumed) {
      continue;
    }
    if (runnerAabbIntersects(playerBox, hitboxToAabb(booster.hitbox))) {
      colliding.push(booster);
    }
  }
  return colliding;
}
